import * as React from 'react';

import { compose } from 'recompose';

import Retracked from 'js/app/retracked';

import ConsumerHeaderFooterWrapper from 'bundles/unified-description-page-common/pages/consumer/ConsumerHeaderFooterWrapper';
import ConsumerPageGuard from 'bundles/unified-description-page-common/pages/consumer/ConsumerPageGuard';
import ConsumerSpecializationPaidMediaPageRootContent from 'bundles/unified-description-page-common/pages/consumer/specialization/ConsumerSpecializationPaidMediaPageRootContent';
import ConsumerSpecializationPaidMediaPageDataProvider from 'bundles/unified-description-page-common/providers/consumer/pages/ConsumerSpecializationPaidMediaPageDataProvider';

const ConsumerSpecializationPaidMediaPageRoot = () => {
  return (
    <ConsumerSpecializationPaidMediaPageDataProvider>
      <ConsumerHeaderFooterWrapper>
        <ConsumerPageGuard>
          <ConsumerSpecializationPaidMediaPageRootContent />
        </ConsumerPageGuard>
      </ConsumerHeaderFooterWrapper>
    </ConsumerSpecializationPaidMediaPageDataProvider>
  );
};

export default compose(
  Retracked.createTrackedContainer(() => ({
    namespace: {
      app: 'unified_description_page',
      page: 'consumer_specialization_paid_media_page',
    },
  }))
)(ConsumerSpecializationPaidMediaPageRoot);
